// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomQuoteLineModel } from "@bg/App/Services/QuoteService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type RfqRequestQuoteState = {
    productLinesQtyToUpdate: CustomQuoteLineModel[];
};

const initialState: RfqRequestQuoteState = {
    productLinesQtyToUpdate: [],
};

const xRfqRequestQuote = createTypedReducerWithImmer(initialState, {
    "Pages/xRfqRequestQuote/UpdateProductsQty": (
        draft: Draft<RfqRequestQuoteState>,
        action: { lineModel: CustomQuoteLineModel & { originalQty?: number } },
    ) => {
        const existingObjectIndex = draft.productLinesQtyToUpdate.findIndex(
            item =>
                item.lineId === action.lineModel.lineId &&
                item.parentId === action.lineModel.parentId &&
                item.originalGroupName === action.lineModel.originalGroupName,
        );

        if (existingObjectIndex !== -1) {
            if (action.lineModel.qtyOrdered === action.lineModel.originalQty) {
                draft.productLinesQtyToUpdate = draft.productLinesQtyToUpdate.filter(
                    (element, index) => index !== existingObjectIndex,
                );
            } else {
                delete action.lineModel.originalQty;
                draft.productLinesQtyToUpdate[existingObjectIndex] = {
                    ...action.lineModel,
                };
            }
        } else {
            delete action.lineModel.originalQty;
            draft.productLinesQtyToUpdate.push(action.lineModel);
        }
    },
    "Pages/xRfqRequestQuote/ClearProductsQty": (draft: Draft<RfqRequestQuoteState>) => {
        draft.productLinesQtyToUpdate = [];
    },
});

(reducers as any).xRfqRequestQuote = xRfqRequestQuote;

export type xRfqRequestQuoteState = {
    xRfqRequestQuote: RfqRequestQuoteState;
};

export type xRfqRequestQuoteReducer = {
    rfqRequestQuote: typeof xRfqRequestQuote;
};

export type xRfqRequestQuoteActions = Parameters<xRfqRequestQuoteReducer[keyof xRfqRequestQuoteReducer]>[1] | AnyAction;
